export class RestService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.headers = {
            json: { headers: { "content-type": "application/json" } },
            multipart: { headers: { "content-type": "multipart/form-data" } },
            tsv: { headers: { "content-type": "text/tab-separated-values" } },
        };
    }
}
//# sourceMappingURL=RestService.js.map